import { Stack, FormControl, TextField } from "@mui/material";
import { ChangeEvent, useCallback, useMemo, useState } from "react";
import { useGetPharmacyStatesQuery } from "src/api/services/pharmacyApi";
import { theme } from "src/assets/theme";
import Spinner from "src/components/Spinner";
import { statesMap } from "src/constants/usStates";
import Centered from "src/shared/Centered";
import PharmacyState from "./components/PharmacyState";

interface Props {
  pharmacyId: number;
  disabled: boolean;
}

function PharmacyStates({ pharmacyId, disabled }: Props) {
  const [search, setSearch] = useState("");
  const { data: states = [], isLoading } =
    useGetPharmacyStatesQuery(pharmacyId);

  const formattedStates = useMemo(
    () =>
      states.map((state) => ({
        ...state,
        name: statesMap[state.state_code],
      })),
    [states]
  );

  const filteredStates = useMemo(() => {
    return formattedStates.filter((state) =>
      state.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [formattedStates, search]);

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  }, []);

  return (
    <Stack p={1}>
      <FormControl fullWidth>
        <TextField
          label="Search"
          fullWidth
          variant="standard"
          value={search}
          onChange={handleChange}
        />
      </FormControl>
      <Stack height={400 - 56} overflow="scroll" width="300px">
        {isLoading ? (
          <Centered>
            <Spinner color={theme.palette.secondary.main} />
          </Centered>
        ) : (
          filteredStates.map((state) => (
            <PharmacyState
              state={state}
              disabled={disabled}
              key={state.state_code}
            />
          ))
        )}
      </Stack>
    </Stack>
  );
}

export default PharmacyStates;
